import { i18n } from "services/i18nService";

import {
  NONE_GROUP_BY_OPTION,
  GROUP_BY_CATEGORY_OR_VENDOR_OPTIONS,
  ON_HAND_VALUE_CALCULATION_OPTION,
  VALUE_CALCULATION_OPTIONS,
  SUB_COMPONENT,
} from "views/Reports/reportConstants";

import { OBJECT_TYPES } from "appConstants";

const UNDERSTOCK_OVERSTOCK_OPTION = {
  id: "Both",
  name: i18n("reports.ShowBothOverstockAndUnderStock"),
};

const OVERSTOCK_OPTION = {
  id: "Overstock",
  name: i18n("reports.ShowOverstockOnly"),
};

const UNDERSTOCK_OPTION = {
  id: "Understock",
  name: i18n("reports.ShowUnderstockOnly"),
};

const UNDERSTOCK_OVERSTOCK_OPTIONS = [
  UNDERSTOCK_OVERSTOCK_OPTION,
  OVERSTOCK_OPTION,
  UNDERSTOCK_OPTION,
];

export const OverstockUnderstockReport = {
  userHasSufficientPrivilege: (p) =>
    p.viewInventory || p.viewItems || p.editItems,
  planIncludesReport: () => true,
  customReportNameFetchList: [
    { objectType: OBJECT_TYPES.ITEM.fullString, customReportKey: "categories" },
    {
      objectType: OBJECT_TYPES.LOCATION.fullString,
      customReportKey: "locations",
    },
    { objectType: OBJECT_TYPES.VENDOR.fullString },
  ],
  customFieldObjectTypes: "item",
  columns: [
    { apiName: "ItemNumber", label: "Item #" },
    { apiName: "Name", default: true },
    { apiName: "Category" },
    { apiName: "Description", default: true },
    { apiName: "Purchase Description" },
    { apiName: "SKU" },
    { apiName: "Barcode" },
    { apiName: "Vendor" },
    { apiName: "VendorPartNumber", label: "Vendor Part #" },
    { apiName: "Sales Price", number: true },
    { apiName: "Purchase Cost", number: true },
    { apiName: "Default Bin" },
    { apiName: "Asset Account" },
    { apiName: "Lead Time", number: true },
    { apiName: "Reorder Point", default: true, number: true },
    { apiName: "Max Stock", default: true, number: true },
    { apiName: "Tags" },
    { apiName: "System Count", number: true, alwaysShow: true },
    { apiName: "Total", number: true, alwaysShow: true },
  ],
  settings: [
    {
      apiName: "date1",
      macroApiName: "date1Macro",
      headerText: i18n("filter.heading.asOf"),
      component: "DateFilter",
      label: i18n("reports.FilterLabel.AsOfDate"),
      datePrefix: "endOf",
      defaultValue: () => new Date(),
      type: "filter",
    },
    {
      apiName: "date1Macro",
      component: SUB_COMPONENT,
      defaultValue: null,
      type: "filter",
    },
    {
      label: i18n("filter.Locations"),
      component: "LocationsFilter",
      apiName: "locations",
      defaultValue: null,
      includeTotalOnlyOption: true,
      placeholder: i18n("reports.placeholder.DefaultIsTotalsOnly"),
      type: "filter",
    },
    {
      label: i18n("filter.Categories"),
      component: "CategoryFilter",
      apiName: "categories",
      defaultValue: null,
      type: "filter",
    },
    {
      label: i18n("filter.Vendor"),
      component: "VendorFilter",
      apiName: "vendor",
      defaultValue: null,
      type: "filter",
    },
    {
      label: i18n("reports.FilterLabel.ItemNameContains"),
      component: "FrmTextField",
      apiName: "nameContains",
      defaultValue: null,
      type: "filter",
    },
    {
      apiName: "showFromTo",
      defaultValue: false,
      label: i18n("reports.OptionLabel.ShowAsOfDate"),
      component: "FrmCheckbox",
      isAsOfDate: true,
      type: "option",
    },
    {
      apiName: "txnType",
      defaultValue: UNDERSTOCK_OVERSTOCK_OPTION,
      label: i18n("reports.OptionLabel.OverstockUnderstock"),
      component: "FrmSelectFromObjects",
      options: UNDERSTOCK_OVERSTOCK_OPTIONS,
      type: "option",
    },
    {
      apiName: "groupBy",
      label: i18n("reports.OptionLabel.GroupBy"),
      component: "FrmButtonGroup",
      defaultValue: NONE_GROUP_BY_OPTION,
      options: GROUP_BY_CATEGORY_OR_VENDOR_OPTIONS,
      type: "option",
    },
    {
      apiName: "valueCalculation",
      defaultValue: ON_HAND_VALUE_CALCULATION_OPTION,
      label: i18n("reports.OptionLabel.ReportValue"),
      component: "FrmSelectFromObjects",
      options: VALUE_CALCULATION_OPTIONS,
      type: "option",
    },
    {
      apiName: "header",
      defaultValue: "",
      label: i18n("global.Header"),
      component: "FrmTextField",
      type: "option",
    },
    {
      apiName: "footer",
      defaultValue: "",
      label: i18n("global.Footer"),
      component: "FrmTextField",
      type: "option",
    },
  ],
};
